import React from "react";
import PropTypes from "prop-types";
// import { get } from "lodash";

import { addAdsToTemplates } from "../get-collection-template";
import { LazyCollection } from "@quintype/components";
import { GA, WebEngage, DeepBI, PGAD } from "../../integrations";
import { DfpAd } from "../atoms/dfp-ad";

const newTemplates = addAdsToTemplates("home");
function getAdsWrappedCollectionTemplate(designTemplate) {
  return newTemplates[designTemplate] || newTemplates.defaultTemplate;
}

export class SpecialPage extends React.Component {
  componentDidMount() {
    GA.registerPageView(this.props.pageType, {});
    WebEngage.registerPageView();
    DeepBI.registerPageView({ collection: this.props });
    PGAD.loadScript();
  }

  render() {
    return (
      <div>
        <LazyCollection
          collection={this.props.data.collection}
          magazine={this.props.data.magazine}
          config={this.props.config}
          collectionTemplates={getAdsWrappedCollectionTemplate}
          lazyAfter={10}
          accentColor={"#404040"}
        />
        <DfpAd className="hidden-mobile" adtype="Roadblock" placement="special" hidetitle={true} />
        <DfpAd className="hidden-mobile" adtype="Subscription_Lightbox" placement="special" hidetitle={true} />
        <DfpAd className="hidden-desktop" adtype="Interstitial" placement="special" hidetitle={true} />
        <DfpAd className="hidden-desktop" adtype="Mobile_lightbox" placement="special" hidetitle={true} />
        {/* {!get(this.props.config, ["disableAds"]) && (
          <div className="container">
            <div data-crowdynews-widget="Vikatan_trending-2019">
              <script src="//widget.crowdynews.com/Vikatan_trending-2019.js" async />
            </div>
          </div>
        )} */}
      </div>
    );
  }
}

SpecialPage.propTypes = {
  data: PropTypes.shape({
    collection: PropTypes.object,
    magazine: PropTypes.array
  }),
  pageType: PropTypes.string,
  config: PropTypes.shape({
    disableAds: PropTypes.bool,
    contentInsightsId: PropTypes.string
  })
};
